import { AppConfigState, AppState } from '@d-store/constant';
import { createSelector } from '@ngrx/store';

const currentAppConfig = (state: AppState) => state.appConfig;

export const getCurrentCurrencyConfig = createSelector(
  currentAppConfig,
  (state: AppConfigState) => ({
    currency: state.generalSetting.currency,
    currencyPrefix: state.generalSetting.currencyPrefix,
  }),
);

export const getCurrentPermission = createSelector(
  currentAppConfig,
  (state) => state.modulePermission,
);
